import { ButtonBase } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import React from 'react'

import { getDirection, lang } from '../../../../localization'
import { WeekDayNamesViewProps } from '../types/DateRangePicker.types'
import useStyles from './styles/weekDayNamesView.style'

const weekDays = {
  jalaali: {
    fa: ['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج'],
    en: ['S', 'S', 'M', 'T', 'W', 'T', 'F']
  },
  gregorian: {
    fa: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    // FA: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    en: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
  }
}

const WeekDayNamesView: React.FC<WeekDayNamesViewProps> = ({
  type,
  onClick = () => {}
}) => {
  const classes = useStyles()
  return (
    <Grid
      container
      className={classes.weekDaysNamesContainer}
      direction={getDirection() === 'ltr' ? 'row' : 'row-reverse'}>
      {weekDays[type || 'gregorian'][lang].map((day, index) => (
        <ButtonBase
          key={`${day}-${index.toString()}`}
          className={classes.weekDayDefaultStyle}
          onClick={() => onClick(index)}>
          {day}
        </ButtonBase>
      ))}
    </Grid>
  )
}

export default WeekDayNamesView
